<template>
  <section :style="{minHeight:(screenHeight-85)+'px'}">
    <div class="step-form__step-num">1/5</div>
    <div class="step-form__main">
      <h1 class="step-form__title">个人信息</h1>
      <el-row :gutter="0">
        <el-col :span="16">
          <el-form class="step-form__form" :label-width="'50%'" :model="step1Form" :rules="rules" ref="step1Form">
            <el-form-item label="姓名" prop="loanAmount" class="step-form__form-item--with-unit">
              <el-input type="text" v-model="step1Form.loanAmount" placeholder="请输入个人姓名"
                        @blur="inputBlurFn('loanAmount')"></el-input>
              <!--<span class="step-form__form-item-unit">元</span>-->
            </el-form-item>
            <el-form-item label="手机号码" prop="loanAmount" class="step-form__form-item--with-unit">
              <el-input type="text" v-model="step1Form.loanAmount" placeholder="请输入手机号码"
                        @blur="inputBlurFn('loanAmount')"></el-input>
              <!--<span class="step-form__form-item-unit">元</span>-->
            </el-form-item>
            <el-form-item label="身份证" prop="loanLimit" class="margin-bottom-0">
              <!--<el-input type="text" v-model="step1Form.loanLimit" placeholder="请输入贷款期限" :maxlength="5"-->
                        <!--@blur="inputBlurFn('loanLimit')"></el-input>-->
              <!--<span class="step-form__form-item-unit">{{selectedTimeUnit.text}}</span>-->
              <span>正反面证照</span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div class="idcard">
        <img src="../../../static/images/banner.png" alt="身份证正面">
        <img src="../../../static/images/banner.png" alt="身份证反面">
      </div>
      <div class="step-form__btn-container">
        <!--<button class="step-form__btn-prev">上一步</button>-->
        <button class="step-form__btn-next" @click="submitForm">下一步</button>
      </div>
    </div>
    <el-dialog class="confirm-loan dialog" v-if="confirmLoanData" :visible="confirmLoanData.show"
               :before-close="cancelLoan" :close-on-click-modal="false">
      <h4 slot="title" class="confirm-loan__dialog-title dialog__title">确认贷款信息</h4>
      <div class="confirm-loan__loan-info">
        <el-row :gutter="0" class="confirm-loan__loan-info-row">
          <el-col :span="3" class="confirm-loan__info--label">贷款产品</el-col>
          <el-col :span="5" class="confirm-loan__info--content">{{confirmLoanData.data.productName}}</el-col>
          <el-col :span="3" class="confirm-loan__info--label">贷款期限</el-col>
          <el-col :span="5" class="confirm-loan__info--content">{{confirmLoanData.data.expires}}{{selectedTimeUnit.text}}</el-col>
          <el-col :span="3" class="confirm-loan__info--label">年化利率</el-col>
          <el-col :span="5" class="confirm-loan__info--content">{{confirmLoanData.data.yearRate}}%</el-col>
        </el-row>
        <el-row :gutter="0" class="confirm-loan__loan-info-row">
          <el-col :span="3" class="confirm-loan__info--label">贷款金额</el-col>
          <el-col :span="5" class="confirm-loan__info--content">{{confirmLoanData.data.money | addThousandSign(2)}}元
          </el-col>
          <el-col :span="3" class="confirm-loan__info--label">还款方式</el-col>
          <el-col :span="5" class="confirm-loan__info--content">{{confirmLoanData.data.repayTypeName}}</el-col>
          <el-col :span="3" class="confirm-loan__info--label">贷款利息</el-col>
          <el-col :span="5" class="confirm-loan__info--content">
            {{confirmLoanData.data.interestMoney | addThousandSign(2)}}元
          </el-col>
        </el-row>
      </div>
      <div class="confirm-loan__repay-plan">
        <h5 class="confirm-loan__repay-plan-title dialog__title">我的还款计划</h5>
        <table class="confirm-loan__repay-plan-table"></table>
        <el-table border :data="confirmLoanData.data.planlist" fit stripe max-height="232"
                  class="confirm-loan__repay-plan-table" style="width: 846px">
          <el-table-column label="期数" width="54px" align="center" :resizable="isResizable">
            <template slot-scope="scope">
              <span class="confirm-loan__repay-plan__periods">{{scope.row.period}}</span>
            </template>
          </el-table-column>
          <el-table-column label="本金/元" min-width="290px" align="center" :resizable="isResizable">
            <template slot-scope="scope">
              {{scope.row.moneybj | addThousandSign(2)}}
            </template>
          </el-table-column>
          <el-table-column label="利息/元" min-width="260px" align="center" :resizable="isResizable">
            <template slot-scope="scope">
              {{scope.row.moneylx | addThousandSign(2)}}
            </template>
          </el-table-column>
          <el-table-column label="还款日期" width="220px" align="center" :resizable="isResizable">
            <template slot-scope="scope">
              {{scope.row.date | formatDate('YYYY-MM-DD')}}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog__footer">
        <button class="dialog__footer__confirm-btn" :loading="isSubmitting" @click="nextStep">确定</button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
  import _ from 'lodash'
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import * as types from '../../vuex/types'

  export default {
    data () {
      const assignValidator = (type, trigger = 'blur', message) => Object.assign({
//        required: true,
        message,
        trigger
      }, {
        validator: (rules, value, callback, source, options) => {
          this.$store.dispatch(type, {rules, value, callback, source, options})
        }
      })
      return {
        isResizable: false,
        isSubmitting: false,
        isSaved: false, // 暂时用于路由离开时候的判断
        repayList: '', //编辑时候的过滤选择下拉框
        screenHeight: document.body.clientHeight,
        loanAmountLimit: {
          min: 0,
          max: 0
        },
        selectedTimeUnit: {
          value: '',
          text: ''
        },
        rules: {
          loanAmount: [{
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value.trim() === '') {
                callback(new Error('请输入贷款金额'))
              } else if (_.isNaN(Number(value))) {
                callback(new Error('贷款金额必须为数字'))
              } else if (value > this.loanAmountLimit.max) {
                callback(new Error(`贷款金额不可以大于${this.loanAmountLimit.max}元`))
              } else if (value < this.loanAmountLimit.min) {
                callback(new Error(`贷款金额不可以小于${this.loanAmountLimit.min}元`))
              } else {
                callback()
              }
            }
          }],
          repayType: [assignValidator(types.VERIFY_MUST_SELECTED, 'change', '请选择还款方式')],
          hasReadContract: [{
            trigger: 'change',
            validator: (rules, value, callback) => {
              if (!value) {
                callback(new Error('必须阅读并同意《贷款协议》'))
              } else {
                callback()
              }
            }
          }]
        },
        step1Form: {
          loanProduct: '',
          loanAmount: '',
          loanLimit: '',
          repayType: '',
          hasReadContract: false
        }
      }
    },
    watch: {
      step1Form: {
        handler (newVal, oldVal) {
          // 为了兼容ie9的placeholder的字体颜色
//          this.$refs.loanProduct.$el.querySelector('input').style.color = '#333'
//          this.$refs.repayType.$el.querySelector('input').style.color = '#333'
        },
        deep: true
      }
    },
    computed: {
      ...mapGetters({
        userInfo: types.GET_USER,
        initialData: types.GET_STEP1_INITIAL_STATE,
        confirmLoanData: types.GET_CONFIRM_LOAN_DATA_STATE
      })
    },
    methods: {
      inputBlurFn (prop) {
        if (event.srcElement) {
          this.step1Form[prop] = event.srcElement.value
        }
      },
      ...mapActions({
        getInitialData: types.GET_STEP1_INITIAL_DATA,
        getSavedData: types.GET_SAVED_STEP1_DATA,
        saveFormData: types.SAVE_STEP1_DATA,
        getConfirmLoanDialog: types.GET_CONFIRM_LOAN_DATA,
        saveApplyLoanProgress: types.SAVE_APPLY_LOAN_PROGRESS
      }),
      ...mapMutations({
        setLoanContract: types.SET_CONTRACT_STATE,
        setConfirmLoanData: types.SET_CONFIRM_LOAN_DATA,
        setRepayType: types.SET_STEP1_INITIAL_DATA_REPAY_TYPE
      }),
      autoSelectProductAndRepayType (loanProductId) {
        // 设置默认选中产品
        // const selectedProduct = this.initialData.loanProductList.filter(item => item.productId === loanProductId)
        // const selectedRepayType = this.initialData.repayTypeList.filter(item => item.baseProductRepay === selectedProduct[0].repayType)
        if (`${this.$route.query.isEdit}` === 'true'){
        const selectedProduct = this.initialData.loanProductList.filter(item => item.productId === loanProductId)

        const selectedProduct1 = selectedProduct[0].repayType.split(",")
        const selectedProduct3 = []
        for (let i=0; i<selectedProduct1.length; i++) {
           const selectedProduct2 = this.initialData.repayTypeList.filter(item => item.baseProductRepay === selectedProduct1[i])
           selectedProduct3.push(selectedProduct2[0])
         }
        this.setRepayType(selectedProduct3)
        } else {
           this.step1Form.loanProduct = loanProductId
        }
        // this.selectedTimeUnit.value = selectedRepayType[0].unitValue
        // this.selectedTimeUnit.text = selectedRepayType[0].unitText
      },
      // switchTimeUnitWithRepayType (val) {
      //   const selectedRepayType = this.initialData.repayTypeList.filter(item => item.baseProductRepay === val)
      //   this.selectedTimeUnit.value = selectedRepayType[0].unitValue
      //   this.selectedTimeUnit.text = selectedRepayType[0].unitText
      // },
      showLoanContract () {
        this.setLoanContract({
          show: true
        })
      },
      cancelLoan () {
        this.setConfirmLoanData({
          show: false
        })
      },
      submitForm () {
//        this.$refs.step1Form.validate((valid) => {
//          if (valid) {
//            const selectedProduct = this.initialData.loanProductList.filter(item => item.productId === this.step1Form.loanProduct)
//            const selectedRepayType = this.initialData.repayTypeList.filter(item => item.baseProductRepay === this.step1Form.repayType)
//            this.getConfirmLoanDialog({
//              token: this.userInfo.token,
//              productId: this.step1Form.loanProduct,
//              productName: selectedProduct[0].productName,
//              repayType: this.step1Form.repayType,
//              repayTypeName: selectedRepayType[0].baseProductRepayName,
//              money: this.step1Form.loanAmount,
//              expires: this.step1Form.loanLimit,
//              expiresUnit: this.selectedTimeUnit.value
//            }).then((res) => {})
//          } else {
//            return false
//          }
//        })
        this.$router.push({
          path: `/applyLoan/${this.$route.params.id}/step2`,
          query: {
            applyLoanId: this.$route.query.applyLoanId, // applyLoanId其实放在store更好吧？
            isEdit: this.$route.query.isEdit
          }
        })
      },
      nextStep () {
        const selectedProduct = this.initialData.loanProductList.filter(item => item.productId === this.step1Form.loanProduct)
        this.isSubmitting = true
        if (`${this.$route.query.isEdit}` === 'true') {
          // 保存数据
          this.saveApplyLoanProgress({
            router: this.$router,
            token: this.userInfo.token,
            step: 1,
            id: this.$route.query.applyLoanId,
            money: this.step1Form.loanAmount,
            expires: this.step1Form.loanLimit,
            expiresUnit: this.selectedTimeUnit.value,
            repayType: this.step1Form.repayType,
            productName: selectedProduct[0].productName,
            productId: this.step1Form.loanProduct
          }).then((res) => {
            this.isSubmitting = false
            if (Number(res.data.code) === 0) {
              this.isSaved = true
              this.$router.push({
                path: `/applyLoan/${this.$route.params.id}/step2`,
                query: {
                  applyLoanId: this.$route.query.applyLoanId, // applyLoanId其实放在store更好吧？
                  isEdit: this.$route.query.isEdit
                }
              })
            }
          })
        } else {
          // 第一步为添加，第二步开始，保存后调用更新项目进度接口
          this.saveFormData({
            router: this.$router,
            token: this.userInfo.token,
            customerType: this.userInfo.crmCustomerType,
            money: this.step1Form.loanAmount,
            expires: this.step1Form.loanLimit,
            expiresUnit: this.selectedTimeUnit.value,
            repayType: this.step1Form.repayType,
            productName: selectedProduct[0].productName,
            productId: this.step1Form.loanProduct
          }).then((res) => {
            this.isSubmitting = false
            if (Number(res.data.code) === 0) {
              this.isSaved = true
              this.$router.push({
                path: `/applyLoan/${this.$route.params.id}/step2`,
                query: {
                  applyLoanId: res.data.data.applyId, // applyLoanId其实放在store更好吧？
                  isEdit: this.$route.query.isEdit
                }
              })
            }
          })
        }
      }
    },
    created () {
      this.cancelLoan()
    },
    mounted () {
      this.$store.commit('changeActive', 1);
      if (`${this.$route.query.isEdit}` === 'true') {
        this.getSavedData({
          router: this.$router,
          token: this.userInfo.token,
          id: this.$route.query.applyLoanId
        }).then((res) => {
          const resData = res.data
          if (Number(resData.code) === 0) {
            const result = resData.data
            this.repayList = result.prolist
            this.isSaved = true
            this.step1Form = {
              loanProduct: result.frontApplyProductId,
              loanAmount: `${result.applyMoney}`,
              loanLimit: `${result.frontApplyExpires}`,
              repayType: result.frontApplyRepayType,
              hasReadContract: true
            }
            switch (Number(result.frontApplyExpiresUnit)) {
              case 1:
                this.selectedTimeUnit = {
                  value: '1',
                  text: '年'
                }
                break
              case 2:
                this.selectedTimeUnit = {
                  value: '2',
                  text: '月'
                }
                break
              case 3:
                this.selectedTimeUnit = {
                  value: '3',
                  text: '天'
                }
                break
              default:
                this.selectedTimeUnit = {
                  value: '3',
                  text: '天'
                }
                break
            }
            // 将计算属性转移去data，不然直接取会失败
            this.loanAmountLimit.min = Number(result.minValue)
            this.loanAmountLimit.max = Number(result.maxValue)
          }
        })
      } else {
        this.getInitialData({
          router: this.$router,
          token: this.userInfo.token,
          productId: this.$route.params.id
        }).then(() => {
          this.autoSelectProductAndRepayType(Number(this.$route.params.id))
          // 将计算属性转移去data，不然直接取会失败
          this.loanAmountLimit.min = Number(this.initialData.minValue)
          this.loanAmountLimit.max = Number(this.initialData.maxValue)
          if (Number(this.initialData.baseProductDeadlineType) === 1) {
            this.selectedTimeUnit.text = '年'
            this.selectedTimeUnit.value = 1
          } else if (Number(this.initialData.baseProductDeadlineType) === 2) {
            this.selectedTimeUnit.text = '月'
            this.selectedTimeUnit.value = 2
          } else if (Number(this.initialData.baseProductDeadlineType) === 3) {
            this.selectedTimeUnit.text = '日'
            this.selectedTimeUnit.value = 3
          } else {
            this.selectedTimeUnit.text = '日'
            this.selectedTimeUnit.value = 3
          }
        })
      }
    },
    beforeRouteLeave (to, from, next) {
      this.setConfirmLoanData({
        show: false
      })
      if (!this.isSaved) {
        // this.submitForm()
        next()
      } else {
        next()
      }
    }
  }
</script>
<style lang="scss">
  .confirm-loan__dialog-title {
    font-size: 20px !important;
  }

  .step1__show-loan-contract {
    color: $orange;
    cursor: pointer;
  }

  .confirm-loan {
    .el-dialog {
      width: 905px;
      margin-left: -452px;
      transform: translateX(0);
      position: absolute;
      left: 50%;
      -ms-transform: translateX(0);
      transform: translateX(0);
    }

    .el-dialog__body {
      padding: 30px 30px 40px;
    }

    .el-dialog__footer {
      padding: 0 30px 30px;
    }
  }

  .confirm-loan__loan-info {
    font-size: 14px;
    font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
  }

  .confirm-loan__loan-info-row {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .confirm-loan__info--label {
    color: $orange;
  }

  .confirm-loan__info--content {
    color: #666;
  }

  .confirm-loan__repay-plan-title {
    margin: 30px 0 20px;
    font-size: 18px;
  }

  .confirm-loan__repay-plan-table {
    border: 1px solid #eee;
    font-size: 14px;
    font-family: "Microsoft YaHei";

    & th {
      background: #ffd2ae;

      & > .cell {
        color: #4d3523;
        /*line-height: 32px;*/
        padding: 0 12px;
        background: #ffd2ae;
      }
    }

    & td, & th.is-leaf {
      border-bottom: 0;
    }

    &.el-table--border td:first-child, &.el-table--border th:first-child {
      border-right: 1px solid rgba(255, 139, 56, .4);
    }

    &.el-table--border td:not(:first-child), &.el-table--border th:not(:first-child) {
      border-right: none;
    }

    &.el-table--striped .el-table__body tr:nth-child(2n - 1) td {
      background: $white;
    }

    &.el-table--striped .el-table__body tr:nth-child(2n) td {
      background: #ffe9d7;
    }

    .el-table__body {
      color: #666;
    }

    .confirm-loan__repay-plan__periods {
      font-size: 12px;
    }
  }

  .protocol_cont {
    margin-top: 35px;

    .el-form-item__error {
      margin-top: -12px;
    }
  }

  .step-form__form {
    .el-select .el-input .el-input__icon {
      /*<!-- -ms-transform: translateY(-50%) rotate(180deg);-->*/
    }
    .el-form-item__content{
      margin-top: 11px;
    }
  }

  .idcard{
    width: 100%;
    img:nth-child(1){
      margin-right:4%;
    }
    img{
      display: inline-block;
      padding: 10px;
      border: 1px dashed #ff8b38;
      border-radius: 5px;
      width: 45%;
      height: 250px;
    }
  }

  .step-form__btn-container{
    margin-top: 20px;
  }

  .fail-modal .el-dialog {
    margin-left: 0px;
  }

</style>



// WEBPACK FOOTER //
// Step1.vue?54548535